import { call, put, takeLatest } from 'redux-saga/effects';

import * as tipActions from './tipActions.js';
import { updateTipBlockApiCall } from './tipAPI.js';

function* updateTipSaga({ payload }) {
  try {
    const { data } = yield call(updateTipBlockApiCall, payload);
    yield put(tipActions.tipUpdateStore(data));
  } catch (error) {
    yield put(tipActions.tipUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* tipWatcher() {
  yield takeLatest(tipActions.tipUpdateRequest.type, updateTipSaga);
}
